export default "__VITE_ASSET__DrR$JX66__"